export const designerUsersFilter = [
  {
    text: "Jurijs",
    value: "jurijs@pprintgroup.com",
  },
  {
    text: "Jekaterina",
    value: "jekaterina@pprintgroup.com",
  },
  {
    text: "Agnese",
    value: "mpdruka@pprintgroup.com",
  },
  {
    text: "Reinis",
    value: "reinis@reinis.lv",
  },
];
